import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "../ui";
import type { ReactNode } from "react";

type Back = { label: ReactNode; onBack: () => void };

/** Rückweg über dem Seitentitel (ab `md`, mit Text). */
export function PageHeaderBackRow({ back }: { back: Back }) {
  return <div className="mq-page-header-back-row">
    <Button type="text" icon={<ArrowLeftOutlined />} onClick={back.onBack}>{back.label}</Button>
  </div>;
}

/** Rückweg als Pfeil vor dem Seitentitel (unter `md`). */
export function PageHeaderBackArrow({ back }: { back: Back }) {
  return <Button type="text" className="mq-page-header-back" icon={<ArrowLeftOutlined />} onClick={back.onBack} title={typeof back.label === "string" ? back.label : undefined}>
    <span className="mq-page-header-back-label">{back.label}</span>
  </Button>;
}
